<template>
    <base-nav container-classes="container-fluid" :show="true"
              class="custom-navbar">

        <template slot="brand">
            <div class="navbar-wrapper">
                <router-link :to="'/user/shops/' + currentUser.defaultshop + '/products/'" class="mr-0 mr-md-2">
                    <img src="../../assets/img/xeo-logo-white.png" class="logo" alt="Federal Bank"/>
                </router-link>
            </div>
        </template>

        <b-navbar-nav class="mr-auto">
            <b-nav-item :to="'/user/cart/'+ currentUser.id + '/'">
                <span class="nav-link-inner--text text-sm">
                    <i class="ni ni-cart mr-1"></i> Cart
                </span>
            </b-nav-item>
<!--            <b-badge variant="secondary" class="ml-1">{{ currentUser.id }}</b-badge>-->
        </b-navbar-nav>
        <UserProfile></UserProfile>
    </base-nav>
</template>
<script>
import { BaseNav } from 'argon/src/components';
import UserProfile from '@/layouts/components/navbar/UserProfile';
import { mapGetters } from 'vuex';

export default {
    components: {
        BaseNav,
        UserProfile
    },
    props: {
        type: {
            type: String,
            default: 'default', // default|light
            description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
        }
    },
    computed: {
        routeName () {
            const { name } = this.$route;
            return this.capitalizeFirstLetter(name);
        },
        ...mapGetters(['currentUser'])
    },
    data () {
        return {
            activeNotifications: false,
            showMenu: false,
            searchModalVisible: false,
            searchQuery: ''
        };
    },
    methods: {
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown () {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown () {
            this.activeNotifications = false;
        },
        toggleSidebar () {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar () {
            this.$sidebar.displaySidebar(false);
        }
    }
};
</script>
<style lang="scss">

.custom-navbar {
    border-bottom: 5px solid #fec43d !important;
    background: #25a7e1;;

    .nav-link {
        color: white !important;
    }

    img.logo {
        max-height: 25px;
    }

}

</style>
